import { render, staticRenderFns } from "./ContratoManage.vue?vue&type=template&id=0b08c723&scoped=true"
import script from "./ContratoManage.vue?vue&type=script&lang=js"
export * from "./ContratoManage.vue?vue&type=script&lang=js"
import style0 from "./ContratoManage.vue?vue&type=style&index=0&id=0b08c723&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08c723",
  null
  
)

export default component.exports